import { ComponentProps, FC } from 'react';
import styled from 'styled-components';
import { Colors, Radio } from '@altermaind/web/ui';
import { convertColorToRgba } from '@/_shared/helpers/convertColorToRgba';

type Props = ComponentProps<typeof Radio> & {
  checkedColor?: keyof Colors;
};

export const StyledRadio = styled(Radio)<Props>(({ theme, checkedColor, checked }) =>
  checkedColor && checked
    ? `
  --radio-circle-override-selected-color: ${convertColorToRgba((theme.colors as Colors)[checkedColor] || '#197EF7', 1)};

  border-color: var(--radio-circle-override-selected-color);

  &:after {
    background: var(--radio-circle-override-selected-color);
  }
`
    : '',
) as FC<Props>;
